<template>
  <v-row class="px-3 pt-1 mb-6" >
    <!-- <p>{{listUsersTranscriptions}}</p> -->
    <v-col cols="12" sm="12" md="12">
      <v-card>
        <v-card-title>
          Active Users
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table v-if="listUsersTranscriptions"
          :items-per-page="5"
          :headers="headers"
          :items="listUsersTranscriptions"
          :search="search"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @click:row="seeDetails"
        >
          <!-- <template v-slot:[`item.transc_timestamp`]="{ item }">
            <span>{{formatDate(item.transc_timestamp)}}</span>
          </template> -->
          <template v-slot:[`item.time`]="{ item }">
            <span>{{formatLength(item.time)}}</span>
          </template>
        </v-data-table>
          <!-- @click:row="seeUser" -->
      </v-card> 
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import { getOrgStats } from "../../plugins/getAnalysics";
import moment from "moment";
// import { formatSecondsToTime } from "../../plugins/timeFormat";

export default {
  name: "OrgDetailData",

  data() {
    return {
      // table settings
      search: '',
      headers: [
        {
          text: 'user_email',
          align: 'start',
          filterable: true,
          value: 'user_email',
        },
        { text: '# transc', value: 'count' },
        { text: 'time (min)', value: 'time' }
      ],
      sortBy: 'time',
      sortDesc: true,

      // data
      listUsersTranscriptions: null,
    };
  },

  props: {
    orgId: {
      default: () => ({})
    },
  },

  computed: {
    ...mapGetters({
      datesrange: "datesrange",
    }),
  },
 
  methods: {
    seeDetails(value) {
      this.$router.push(`/users/${value.user_id}`);
    },
    formatDate(date){
      let a = moment(new Date(date.value)).format("DD/MM/YYYY")
      return a
    },
    formatLength(value) {
      let a = (value / 60).toFixed(0)
      return a
    },
    async getTranscriptionsLists(){
      const listUsersTranscriptions = await getOrgStats({ queryType: 'listUsersTranscriptions', orgId: this.orgId, datesrange: this.datesrange })
      this.listUsersTranscriptions = listUsersTranscriptions.data
      // if(this.orgId != ''){
        
      // } else {
      //   const listOrgTranscriptions = await getOrgStats({ queryType: 'listTranscriptions', datesrange: this.datesrange })
      //   this.listTranscriptions = listOrgTranscriptions.data
      // }
    },
  },

  async mounted(){
    this.getTranscriptionsLists();
  },

}
</script>

<style>

</style>